import {
    COMMISSIONS_CLEAN_AVAILABLE_PERIODS_SUCCESS
  } from '../constants'
  
  export function reducer(state, action) {
    if (action.type === COMMISSIONS_CLEAN_AVAILABLE_PERIODS_SUCCESS) {
        return {
          ...state,
          policies: {
              ...state.policies,
              commissionsMonths: [],
              getCommissionsMonthPending: false,
              createPolicyCopyError: false,
              createPolicyCopySuccess: false,
          }
        }
      }
    else {
        return state
      }
  }
  